export default "__VITE_ASSET__D18gDmL2__"